export const playback = {
  input: {
    media: {
      label: 'Аудиофайлы'
    },

    select_file: 'Выбрать файл | Выбрать файлы'
  },

  state: {
    init: {
      description:
        'Позволяет воспроизвести клиенту нужную аудиозапись. Прослушать и загрузить аудиозаписи можно в разделе'
    }
  }
};
